import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../services/admin.service';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { Schedule } from '../../../models/schedule.model';
import { TimeFormatterService } from '../../../services/time-formatter.service';
import { isUndefined } from 'util';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { PrefixService } from '../../../services/frefix.service';
import { UserService } from '../../../services/user.service';
import { User } from '../../../models/user.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateSchedulePopupComponent } from '../../admin/create-schedule-popup/create-schedule-popup.component';
import { ConfirmPopupComponent } from '../view-group/popups/confirm-popup copy/confirm-popup.component';

@Component({
  selector: 'app-edit-group-details',
  templateUrl: './edit-group-details.component.html',
  styleUrls: ['./edit-group-details.component.css'],
})
export class EditGroupDetailsComponent implements OnInit {
  isLoaded = false;
  showErrorMsg = false;
  loadingErrorMsg = '';
  departmentsForm: FormGroup;
  public group: any;
  public name: string;
  public workSchedule: Schedule;
  public workSchedule2: Schedule;
  public workSchedule3: Schedule;
  public schedulesList: any[] = [];
  public schedulesListNoFormated: any;
  public selectedScheduleName = 'SELECT';
  public selectedScheduleName2 = 'SELECT';
  public selectedScheduleName3 = 'SELECT';
  public successInfo = false;
  public errorInfo = false;
  validationFailed: boolean;
  getSubdivisionsErrorInfo = false;
  getAffiliatesErrorInfo = false;
  getGlobalsErrorInfo = false;
  noSubdivisionsInfo = false;
  noAffiliatesInfo = false;
  noGlobalsInfo = false;
  isEditBtnDisabled = true;
  isAffiliate = false;
  isDepartment = false;
  selectedType = 'GLOBAL';
  subdivisions = [];
  affiliates = [];
  globals = [];
  selectedSubdivisions = [];
  selectedSubdivision = '';
  selectedSubdivisionId = '';
  selectedScheduleId = '';
  selectedScheduleId2 = '';
  selectedScheduleId3 = '';
  selectedAffiliate = '';
  selectedAffiliateId = '';
  selectedAffiliateObj = null;
  selectedGlobal = '';
  selectedGlobalId = '';
  titleValue = '';
  errorName = false;
  currentGroupName = '';
  currentGroupType = '';
  infoLoaded = false;
  moveToType = '';
  currentGroupRelatives = [];
  errorMsg = '';
  myCroupPrefix;
  prefix;
  user: User;
  isAdmin = false;
  isHead = false;
  isUser = false;
  flag = true;
  id;
  workScheduleCheckvox = false;
  workSchedule2Checkvox = false;
  workSchedule3Checkvox = false;
  sheduleListFlexible;
  flexShedulesDeratment;
  currentShedList = [];
  dropdowns: { id?: any, open: boolean, selected: any, selectedScheduleName?: string, period: any, schedules: { workDays: number, restDays: number }[] }[] = [];
  from: Date;
  sheduleId: string;
  messageSuccess;
  messageDanger;
  scheduleDropdowns: any[] = [];
  today: string;
  currentListSHedulerTeamBuilding;
  currentUser;
  scheduleList = [];
  allSchedulesUsed: boolean = false;
  checkSheduleList = [];
  isAnyScheduleAvailable: boolean = true;
  isLoading = false;
  constName = null;
  originalDropdowns;

  constructor(public adminService: AdminService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    public prefixService: PrefixService,
    private userService: UserService) {
    this.id = this.route.snapshot.params['id'];
    this.currentUser = JSON.parse(localStorage.getItem('User')).mainGroup;
  }

  ngOnInit() {
    this.checkRole();
    this.getGroupInfoById();
    const todayDate = new Date();
    const tomorrowDate = new Date(todayDate);
    tomorrowDate.setDate(todayDate.getDate() + 1);
    
    const year = tomorrowDate.getFullYear();
    const month = tomorrowDate.getMonth() + 1;
    const day = tomorrowDate.getDate();
    
    this.today = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
  }

  onTabChange(event) {
    if(event.nextId == 'flex'){
      this.scheduleDropdowns = [];
      this.scheduleList = [];
      this.checkSheduleList = [];
      this.getSchedulesList();
    }
    if(event.nextId == 'build'){
      this.getGroupInfoById();
    }
  }

  openNewSchedule() {
    this.scheduleDropdowns.unshift({
      title: '',
      groupId: this.group.id,
      scheduleId: '',
      from: '',
      users: this.group.activeUsers.map(activeUser => ({
        user: activeUser.user,
        selected: false
      })),
      open: true
    });
  }

  pushData(data: any[]): void {
    const openStates = this.scheduleDropdowns ? this.scheduleDropdowns.map(scheduleDropdown => scheduleDropdown.open) : [];

    this.scheduleDropdowns = data.map(group => ({
      title: group.title,
      id: group.id,
      scheduleId: group.schedule ? group.schedule.id : '',
      schedule: group.schedule ? group.schedule : {},
      from: group.from,
      open: openStates.length ? openStates.find((state, index) => this.scheduleDropdowns[index].id === group.id) : false,
      users: this.group.activeUsers.map(activeUser => ({
        user: activeUser.user,
        selected: group.users.some(groupUser => groupUser.id === activeUser.user.id)
      }))
    }));

    this.checkList();
  }

  updateUserSelection(scheduleIndex: number, userId: string): void {
    const scheduleDropdown = this.scheduleDropdowns[scheduleIndex];
    const userIndex = scheduleDropdown.users.findIndex(user => user.id === userId);
    if (userIndex > -1) {
      scheduleDropdown.users[userIndex].selected = !scheduleDropdown.users[userIndex].selected;
    }
  }

  saveSchedule(scheduleIndex: number) {
    const newSchedule = this.scheduleDropdowns[scheduleIndex];
    const selectedUserIds = newSchedule.users.filter(user => user.selected).map(user => user.user.id);
    const requestData = {
      title: newSchedule.title,
      groupId: this.group.id,
      scheduleId: newSchedule.scheduleId,
      from: newSchedule.from,
      users: selectedUserIds
    }
    this.addTemplateTeamBuilding(requestData, scheduleIndex);
  }

  getAllTeamBuilding() {
    this.adminService.getAllTeamBuilding(this.group.id).subscribe(
      suc => {
        let list = suc;
        list.reverse();
        this.currentListSHedulerTeamBuilding = list;
        this.pushData(list);
      },
      err => {

      }
    )
  }

  addTemplateTeamBuilding(params, scheduleIndex) {
    this.isLoading = true;
    this.adminService.teamScheduleBuilding(params).subscribe(
      suc => {
        this.isLoading = false;
        this.getAllTeamBuilding();
        this.messageDanger = '';
        this.messageSuccess = 'SCHEDULE_CREATING';
        setTimeout(() => {
          this.messageSuccess = '';
        }, 3000);
      },
      err => {
        this.isLoading = false;
      }
    )
  }

  getFilteredScheduleList(currentId: number): any[] {
    return this.scheduleList.filter(item => 
      !this.scheduleDropdowns.some(dropdown => dropdown.scheduleId === item.id) || item.id === currentId
    );
  }

  onScheduleChange(scheduleIndex: number): void {
    const scheduleDropdown = this.scheduleDropdowns[scheduleIndex];
    if (scheduleDropdown.id) {
      this.updateTeamScheduleBuildingShedule(scheduleDropdown.id, scheduleDropdown.scheduleId);
    }
  }

  updateTeamScheduleBuildingShedule(id, scheduleId) {
    this.isLoading = true;
    this.adminService.updateTeamScheduleBuilding(id, scheduleId).subscribe(
      suc => {
        this.isLoading = false;
        this.messageDanger = '';
        this.messageSuccess = 'SCHEDULE_UPDATING';
        setTimeout(() => {
          this.messageSuccess = '';
        }, 3000);
      },
      err => {
        this.isLoading = false;
      }
    )
  }

  updateTeamScheduleBuildingUsers(id, idUser): void {
    this.isLoading = true;
    const openStates = this.scheduleDropdowns.map(scheduleDropdown => scheduleDropdown.open);

    this.adminService.updateTeamAddUser(id, idUser).subscribe(
      suc => {
        this.messageDanger = '';
        this.messageSuccess = 'USER_ADDED';
        this.getAllTeamBuilding();
        setTimeout(() => {
          this.messageSuccess = '';
          this.scheduleDropdowns.forEach((scheduleDropdown, index) => {
            scheduleDropdown.open = openStates[index];
          });
        }, 3000);
      },
      err => {
        this.isLoading = false;
        console.error('Error adding user:', err);
      }
    );
  }

  deleteTeamScheduleBuildingUsers(id, idUser) {
    this.isLoading = true;
    this.adminService.updateTeamRemoveUser(id, idUser).subscribe(
      suc => {
        this.isLoading = false;
        this.messageSuccess = '';
        this.messageDanger = 'USER_DELETED';
        this.getAllTeamBuilding()
        setTimeout(() => {
          this.messageDanger = '';
        }, 3000);
      },
      err => {

      }
    )
  }

  openmodalDel(id, scheduleIndex){
    const modalRef = this.modalService.open(ConfirmPopupComponent);
    modalRef.result.then((result) => {
			if (result === 'ok') {
        this.deletebataysk(id, scheduleIndex);
			}
		});
  }

  deletebataysk(id: string, scheduleIndex: number): void {
    this.isLoading = true;
    this.adminService.deleteTeamScheduleBuilding(id).subscribe(
      suc => {
        this.isLoading = false;
        this.getAllTeamBuilding();
        this.messageSuccess = '';
        this.messageDanger = 'TEAM_DELETED';
        setTimeout(() => {
          this.messageDanger = '';
        }, 3000);
      },
      err => {
        this.isLoading = false;
      }
    );
  }

  routTo(id) {
    this.router.navigateByUrl('/dashboard/admin/create-schedule/' + id)
  }

  addDropdown(result) {
    this.dropdowns.push({
      selectedScheduleName: '',
      period: {
        endOfTheLunch: '',
        endOfTheWorkingDay: '',
        theBeginingOfTheLunch: '',
        theBeginingOfTheWorkDay: '',
      },
      schedules: [],
      open: false,
      selected: false
    });
    const newIndex = this.dropdowns.length - 1;
    this.updatePeriod(newIndex, result);
  }

  addSchedule(dropdownIndex: number, event: Event) {
    event.stopPropagation();
    this.dropdowns[dropdownIndex].schedules.push({ workDays: 1, restDays: 1 });
  }

  updateWorkDays(dropdownIndex: number, scheduleIndex: number, workDays: number) {
    this.dropdowns[dropdownIndex].schedules[scheduleIndex].workDays = workDays < 1 ? 1 : workDays;
  }

  updateRestDays(dropdownIndex: number, scheduleIndex: number, restDays: number) {
    this.dropdowns[dropdownIndex].schedules[scheduleIndex].restDays = restDays < 1 ? 1 : restDays;
  }

  validateInput(dropdownIndex: number, scheduleIndex: number, field: string) {
    if (field === 'workDays') {
      this.dropdowns[dropdownIndex].schedules[scheduleIndex].workDays = this.dropdowns[dropdownIndex].schedules[scheduleIndex].workDays < 1 ? 1 : this.dropdowns[dropdownIndex].schedules[scheduleIndex].workDays;
    } else if (field === 'restDays') {
      this.dropdowns[dropdownIndex].schedules[scheduleIndex].restDays = this.dropdowns[dropdownIndex].schedules[scheduleIndex].restDays < 1 ? 1 : this.dropdowns[dropdownIndex].schedules[scheduleIndex].restDays;
    }
  }

  removeSchedule(dropdownIndex: number, scheduleIndex: number) {
    this.dropdowns[dropdownIndex].schedules.splice(scheduleIndex, 1);
  }

  removeDropdown(dropdownIndex: number) {
    this.dropdowns.splice(dropdownIndex, 1);
  }

  saveSchedules(dropdownIndex: number) {
    this.createSchedule(this.dropdowns[dropdownIndex], dropdownIndex);
  }

  createSchedule(schedule, dropdownIndex) {
    let currentShedule = {
      workStart: schedule.period.theBeginingOfTheWorkDay,
      lunchStart: schedule.period.theBeginingOfTheLunch,
      lunchEnd: schedule.period.endOfTheLunch,
      workEnd: schedule.period.endOfTheWorkingDay,
      type: "FLEXIBLE",
      segments: schedule.schedules

    }
    this.adminService.createSchedule(currentShedule).subscribe(
      (response: any) => {
        if (response.status === 201 || response.status === 200) {
          this.dropdowns[dropdownIndex].id = response.body.id;
          this.successInfo = true;
          this.errorInfo = false;
        }
      },
      () => {
        this.successInfo = false;
        this.errorInfo = true;
      }
    );
  }

  openSchedule() {
    const modalRef = this.modalService.open(CreateSchedulePopupComponent, { size: 'lg', backdrop: 'static', windowClass: 'full-screen-modal' });
    modalRef.componentInstance.type = 'MODAL';
    modalRef.result.then((result) => {
      if (this.isValidResult(result)) {
        this.addDropdown(result);
      } else {
        console.error('Invalid schedule structure:', result);
      }
    });
  }

  isValidResult(result: any): boolean {
    const expectedKeys = ['theBeginingOfTheWorkDay', 'theBeginingOfTheLunch', 'endOfTheLunch', 'endOfTheWorkingDay'];
    return expectedKeys.every(key => result.hasOwnProperty(key));
  }

  updatePeriod(dropdownIndex: number, schedule: any) {
    this.dropdowns[dropdownIndex].open = !this.dropdowns[dropdownIndex].open;
    this.dropdowns[dropdownIndex].period.endOfTheLunch = schedule.endOfTheLunch;
    this.dropdowns[dropdownIndex].period.endOfTheWorkingDay = schedule.endOfTheWorkingDay;
    this.dropdowns[dropdownIndex].period.theBeginingOfTheLunch = schedule.theBeginingOfTheLunch;
    this.dropdowns[dropdownIndex].period.theBeginingOfTheWorkDay = schedule.theBeginingOfTheWorkDay;
    this.dropdowns[dropdownIndex].selectedScheduleName = `${schedule.theBeginingOfTheWorkDay} - ${schedule.endOfTheWorkingDay}`;
  }

  checkRole() {
    this.user = this.userService.getLocal();
    if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
      this.isHead = true;
    } else {
      this.isHead = false;
    }
    if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
    }
    if (this.user.roles.indexOf('ROLE_USER') !== -1) {
      this.isUser = true;
    } else {
      this.isUser = false;
    }
  }

  titleValueEmpty(value) {
    value = value.trim();
    this.isEditBtnDisabled = !(value !== '' && value !== undefined);
  }

  checkList(): void {
    const availableSchedules = this.checkSheduleList.filter(item => !this.scheduleDropdowns.some(dropdown => dropdown.scheduleId === item.id));
    this.isAnyScheduleAvailable = availableSchedules.length > 0;
    this.isLoading = false;
  }

  getGroupInfoById() {
    this.isLoaded = false;
    this.showErrorMsg = false;
    this.loadingErrorMsg = '';

    this.adminService.getGroupByID(this.route.snapshot.params['id']).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.group = response.body;
          this.scheduleList = this.group.flexibleWorkSchedule;
          this.getAllTeamBuilding()
          this.flexShedulesDeratment = this.group.flexibleWorkSchedule;
          this.checkSheduleList = this.group.flexibleWorkSchedule;
          this.name = this.group.name;
          this.titleValue = this.name;
          this.currentGroupName = this.name;
          this.currentGroupType = this.group.groupType;
          this.selectedScheduleId = this.group.workSchedule.id;
          if (this.group.workScheduleId2) {
            this.selectedScheduleId2 = this.group.workScheduleId2.id;
          }
          if (this.group.workScheduleId3) {
            this.selectedScheduleId3 = this.group.workScheduleId3.id;
          }
          this.workScheduleCheckvox = response.body.workScheduleCheckvox;
          this.workSchedule2Checkvox = response.body.workSchedule2Checkvox;
          this.workSchedule3Checkvox = response.body.workSchedule3Checkvox;
          this.titleValueEmpty(this.name);
          this.infoLoaded = true;
          this.selectType(this.currentGroupType);
          this.currentGroupRelatives = this.group.relativeGroup;
          this.selectedSubdivisions = this.currentGroupRelatives;
          this.selectedSubdivisions.forEach(ssd => {
            if (ssd === null) {
              const index = this.selectedSubdivisions.indexOf(ssd);
              this.selectedSubdivisions.splice(index, 1);
            }
          });
          this.getSchedulesList();
          this.retryGroups();
        } else {
          this.isLoaded = true;
          this.showErrorMsg = true;
          this.loadingErrorMsg = 'ERROR_LOADING_DEPARTMENT';
        }
      },
      () => {
        this.isLoaded = true;
        this.showErrorMsg = true;
        this.loadingErrorMsg = 'ERROR_LOADING_DEPARTMENT';
      },
      () => {
        this.workSchedule = this.group.workSchedule;
        if (this.group.workScheduleId2) {
          this.workSchedule2 = this.group.workScheduleId2;
        }
        if (this.group.workScheduleId3) {
          this.workSchedule3 = this.group.workScheduleId3;
        }
        this.selectedScheduleName = this.workSchedule.workStart.substr(0, this.workSchedule.workStart.length - 3) + ' - ' + this.workSchedule.workEnd.substr(0, this.workSchedule.workEnd.length - 3);
        if (this.group.workScheduleId2) {
          this.selectedScheduleName2 = this.workSchedule2.workStart.substr(0, this.workSchedule2.workStart.length - 3) + ' - ' + this.workSchedule2.workEnd.substr(0, this.workSchedule2.workEnd.length - 3);
        }
        if (this.group.workScheduleId3) {
          this.selectedScheduleName3 = this.workSchedule3.workStart.substr(0, this.workSchedule3.workStart.length - 3) + ' - ' + this.workSchedule3.workEnd.substr(0, this.workSchedule3.workEnd.length - 3);
        }
      }
    )
  }


  saveSelectedSchedulesForUpdateTitle() {
    const selectedIds = this.dropdowns
      .filter(item => item.selected)
      .map(item => item.id);
    this.editDivision(selectedIds);
  }

  saveSelectedSchedules(list) {
    const selectedIds = list
      .filter(item => item.selected)
      .map(item => item.id);
    this.editAllDivisions(selectedIds);
  }

  retryGroups() {
    this.prefixService.getPrefixesForGroup(this.route.snapshot.params['id']).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.myCroupPrefix = response.body[0];
          this.prefixService.setGroupPrefixex(response.body);
          this.prefixService.setSelectedPrefix(this.prefixService.getGroupPrefixex()[0]);
          this.prefix = this.prefixService.getGroupPrefixex()[0].name;
          this.isLoaded = true;
        } else if (response.status === 204) {
          this.isLoaded = true;
          this.prefixService.setGroupPrefixex([]);
          this.prefixService.setSelectedPrefix(null);
        }
      },
      () => {
        this.isLoaded = true;
      },
      () => {
        this.isLoaded = true;
      }
    );
  }

  editPrefix() {
    this.prefixService.editPrefixInGroupPre(this.myCroupPrefix).subscribe(
      (response: any) => {
        if (response.status === 200 || response.status === 208) {
          this.errorInfo = false;
          //this.successInfo = true;
          if ((this.prefixService.getGroupPrefixex().length) > 0) {
            this.prefixService.setSelectedPrefix(this.prefixService.getGroupPrefixex()[0]);
          } else {
            this.prefixService.setSelectedPrefix(null);
          }
        }
      },
      (error) => {
        this.successInfo = false;
        this.errorInfo = true;
        this.errorMsg = 'PREFIX_IS_USE';
      }
    );
  }


  getSchedulesList() {
    let that = this;
    this.adminService.getSchedules().subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.schedulesListNoFormated = response.body.STANDARD;
          this.sheduleListFlexible = response.body.FLEXIBLE;
          this.initializeDropdowns();
          that.schedulesListNoFormated.forEach(function (el, i) {
            if (that.selectedScheduleId && el.id == that.selectedScheduleId) that.schedulesListNoFormated.splice(i, 1);
          })
          that.schedulesListNoFormated.forEach(function (el, i) {
            if (that.selectedScheduleId2 && el.id == that.selectedScheduleId2) that.schedulesListNoFormated.splice(i, 1);
          })
          that.schedulesListNoFormated.forEach(function (el, i) {
            if (that.selectedScheduleId3 && el.id == that.selectedScheduleId3) that.schedulesListNoFormated.splice(i, 1);
          })
          this.getAffiliates();
        } else {
          this.isLoaded = true;
          this.showErrorMsg = true;
          this.loadingErrorMsg = 'ERROR_LOADING_SCHEDULES_LIST';
        }
      },
      () => {
        this.isLoaded = true;
        this.showErrorMsg = true;
        this.loadingErrorMsg = 'ERROR_LOADING_SCHEDULES_LIST';
      }
    );
  }

  initializeDropdowns() {
    this.dropdowns = this.sheduleListFlexible.map(item => ({
      id: item.id,
      open: false,
      selectedScheduleName: `${item.workStart} - ${item.workEnd}`,
      schedules: item.segments || [],
      selected: this.flexShedulesDeratment.some(otherItem => otherItem.id === item.id)
    }));
    this.originalDropdowns = JSON.parse(JSON.stringify(this.dropdowns));
  }

  getDepartments() {
    this.adminService.getDepartmentGroups().subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.subdivisions = response.body;
          const formControls = this.subdivisions.map(control =>
            this.isSelectedSubdivision(control.id) ?
              new FormControl(true) : new FormControl(false));
          this.departmentsForm = this.fb.group({
            subdivisions: new FormArray(formControls),
          });
          this.getSubdivisionsErrorInfo = false;
          if (this.subdivisions.length > 0) {
            this.noSubdivisionsInfo = false;
          } else {
            this.noSubdivisionsInfo = true;
            this.selectedSubdivision = 'NO_SUBDIVISIONS';
          }
          this.isLoaded = true;
          this.showErrorMsg = false;
          this.loadingErrorMsg = '';
        } else {
          this.isLoaded = true;
          this.showErrorMsg = true;
          this.loadingErrorMsg = 'ERROR_LOADING_SUBDIVISIONS_LIST';
        }
      },
      (error) => {
        this.noSubdivisionsInfo = true;
        this.getSubdivisionsErrorInfo = true;
        this.selectedSubdivision = 'Can\'t get any subdivisions';
        this.isLoaded = true;
        this.showErrorMsg = true;
        this.loadingErrorMsg = 'ERROR_LOADING_SUBDIVISIONS_LIST';
      }
    );
  }

  getAffiliates() {
    this.adminService.getAffiliateGroups().subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.affiliates = response.body;
          this.getAffiliatesErrorInfo = false;
          if (this.affiliates.length > 0) {
            this.noAffiliatesInfo = false;
            this.selectAffiliate(this.affiliates[0]);
          } else {
            this.noAffiliatesInfo = true;
            this.selectedAffiliate = 'NO_AFFILIATE_GROUPS';
          }
          this.getGlobals();
        } else {
          this.isLoaded = true;
          this.showErrorMsg = true;
          this.loadingErrorMsg = 'ERROR_LOADING_AFFILIATES_LIST';
        }
      },
      () => {
        this.noAffiliatesInfo = true;
        this.getAffiliatesErrorInfo = true;
        this.selectedAffiliate = 'C_A_G';
        this.isLoaded = true;
        this.showErrorMsg = true;
        this.loadingErrorMsg = 'ERROR_LOADING_AFFILIATES_LIST';

      }
    );
  }

  getGlobals() {
    this.adminService.getGlobalGroups().subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.globals = response.body;
          this.getGlobalsErrorInfo = false;
          if (this.globals.length > 0) {
            this.noGlobalsInfo = false;
            this.selectGlobal(this.globals[0]);
          } else {
            this.noGlobalsInfo = true;
            this.selectedAffiliate = 'NO_GLOBAL_GROUPS';
          }
          this.affiliates.forEach(aff => {
            if (aff.id === this.group.relativeGroup[0]) {
              this.selectAffiliate(aff);
            }
          });
          this.getDepartments();
        } else {
          this.isLoaded = true;
          this.showErrorMsg = true;
          this.loadingErrorMsg = 'E_G_D_L';
        }
      },
      (error) => {
        this.noGlobalsInfo = true;
        this.getGlobalsErrorInfo = true;
        this.selectedGlobal = 'C_G_A_G';
        this.isLoaded = true;
        this.showErrorMsg = true;
        this.loadingErrorMsg = 'E_G_D_L';
      }
    );
  }

  selectedSchedule(schedule, index) {
    if (this.workSchedule) {
      this.schedulesListNoFormated.push(this.workSchedule);
      this.schedulesListNoFormated.splice(index, 1);
    } else {
      this.schedulesListNoFormated.splice(index, 1);
    }
    this.workSchedule = schedule;
    this.group.workSchedule = schedule;
    this.selectedScheduleName = schedule.workStart.substr(0, schedule.workStart.length - 3) + ' - ' + schedule.workEnd.substr(0, schedule.workEnd.length - 3);
    this.selectedScheduleId = schedule.id;
  }

  selectedSchedule2(schedule, index) {
    if (this.workSchedule2) {
      this.schedulesListNoFormated.push(this.workSchedule2);
      this.schedulesListNoFormated.splice(index, 1);
    } else {
      this.schedulesListNoFormated.splice(index, 1);
    }
    this.workSchedule2 = schedule;
    this.group.workSchedule2 = schedule;
    this.selectedScheduleName2 = schedule.workStart.substr(0, schedule.workStart.length - 3) + ' - ' + schedule.workEnd.substr(0, schedule.workEnd.length - 3);
    this.selectedScheduleId2 = schedule.id;
  }

  selectedSchedule3(schedule, index) {
    if (this.workSchedule3) {
      this.schedulesListNoFormated.push(this.workSchedule3);
      this.schedulesListNoFormated.splice(index, 1);
    } else {
      this.schedulesListNoFormated.splice(index, 1);
    }
    this.workSchedule3 = schedule;
    this.group.workSchedule3 = schedule;
    this.selectedScheduleName3 = schedule.workStart.substr(0, schedule.workStart.length - 3) + ' - ' + schedule.workEnd.substr(0, schedule.workEnd.length - 3);
    this.selectedScheduleId3 = schedule.id;
  }

  selectType(type) {
    if (type === 'AFFILIATE') {
      this.isAffiliate = true;
      this.isDepartment = false;
      this.selectedSubdivisions = [];
    }
    if (type === 'DEPARTMENT') {
      this.isAffiliate = false;
      this.isDepartment = true;
      this.selectedSubdivisions = [];
    }
    if (type === 'GLOBAL') {
      this.selectedSubdivisions = [];
      this.isAffiliate = false;
      this.isDepartment = false;
      this.selectSubdivision('');
    }
    this.selectedType = type;
  }

  selectSubdivision(subdivision) {
    this.selectedSubdivision = subdivision.name;
    this.selectedSubdivisionId = subdivision.id;
  }

  selectAffiliate(affiliate) {
    this.selectedAffiliate = affiliate.name;
    this.selectedAffiliateId = affiliate.id;
    this.selectedAffiliateObj = affiliate;
  }

  selectGlobal(global) {
    this.selectedGlobal = global.name;
    this.selectedGlobalId = global.id;
  }

  appendSubdivision(subdivision) {
    if (this.selectedSubdivisions.includes(subdivision)) {
      const index: number = this.selectedSubdivisions.indexOf(subdivision);
      if (index !== -1) {
        this.selectedSubdivisions.splice(index, 1);
      }
    } else {
      this.selectedSubdivisions.push(subdivision);
    }
  }

  isSelectedSubdivision(subdivision) {
    return this.selectedSubdivisions.includes(subdivision);
  }

  editDivision(list) {
    this.isLoading = true;
    this.editPrefix();
    this.errorMsg = '';
    this.successInfo = false;
    this.errorInfo = false;
    this.errorName = false;
    const group = {
      name: this.titleValue,
      id: this.group.id,
      workScheduleId: this.selectedScheduleId,
      workScheduleId2: this.selectedScheduleId2 ? this.selectedScheduleId2 : null,
      workScheduleId3: this.selectedScheduleId3 ? this.selectedScheduleId3 : null,
      workScheduleCheckvox: this.workScheduleCheckvox,
      workSchedule2Checkvox: this.workSchedule2Checkvox,
      workSchedule3Checkvox: this.workSchedule3Checkvox,
      flexibleWorkSchedules: list,
      groupType: this.selectedType,
      relativeGroup: [
        this.selectedSubdivisionId
      ]
    };
    if (this.titleValue === this.currentGroupName) {
      group.name = null;
    } else {
      this.currentGroupName = group.name;
    }
    if (this.selectedType === 'AFFILIATE') {
      group.relativeGroup = this.selectedSubdivisions;
    }
    this.adminService.updateGroup(group).subscribe(
      (response: any) => { 
        this.isLoading = false;
        this.messageDanger = '';
        this.messageSuccess = 'SCHEDULE_UPDATING';
        setTimeout(() => {
          this.messageSuccess = '';
        }, 3000);
      },
      (err) => {
        this.isLoading = false;
        this.messageSuccess = '';
        this.messageDanger = '';
        setTimeout(() => {
          this.messageSuccess = '';
        }, 3000);
      }
    );
  }

  moveToGlobal() {
    const group = {
      parentName: this.selectedGlobal,
      id: this.group.id,
      relativeGroup: this.currentGroupRelatives
    };
    this.moveToType = 'global';
    this.adminService.convertGroup(group, this.moveToType).subscribe(
      (response: any) => {
        if (response.status === 200) {
          if (this.currentGroupType === 'DEPARTMENT') {
            this.convertGroupType();
          } else if (this.currentGroupType === 'GLOBAL' || this.currentGroupType === 'AFFILIATE') {
            this.addRelative();
          }
        } else {
          this.errorMsg = 'ERROR_MOVING_TO_GLOBAL';
          this.successInfo = false;
          this.errorInfo = true;
        }
      },
      () => {
        this.errorMsg = 'ERROR_MOVING_TO_GLOBAL';
        this.successInfo = false;
        this.errorInfo = true;
      }
    );
  }

  convertGroupType() {
    const group = {
      id: this.group.id,
      relativeGroup: []
    };
    if (this.selectedType === 'GLOBAL') {
      group.relativeGroup = null;
    }
    if (this.currentGroupType === 'AFFILIATE') {
      group.relativeGroup = [];
      group.relativeGroup.push(this.selectedGlobalId);
      this.moveToType = 'global';
    }
    if (this.currentGroupType === 'DEPARTMENT') {
      group.relativeGroup = [];
      group.relativeGroup.push(this.selectedAffiliateId);
      this.moveToType = 'affiliate';
    }
    this.adminService.convertGroup(group, this.moveToType).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.successInfo = true;
          this.errorInfo = false;
          this.errorName = false;
        } else {
          this.errorMsg = 'ERROR_CONVERTING_GROUP_TYPE';
          this.successInfo = false;
          this.errorInfo = true;
        }
      },
      () => {
        this.errorMsg = 'ERROR_CONVERTING_GROUP_TYPE';
        this.successInfo = false;
        this.errorInfo = true;
      }
    );
  }

  addRelative() {
    const group = {
      id: this.group.id,
      relativeGroup: []
    };
    if (this.selectedType === 'AFFILIATE') {
      group.relativeGroup = this.selectedSubdivisions;
    }
    if (this.selectedType === 'GLOBAL') {
      group.relativeGroup = this.selectedSubdivisions;
    }
    if (this.currentGroupType === 'DEPARTMENT') {
      group.relativeGroup.push(this.selectedAffiliateId);
    }
    group.relativeGroup.forEach(rg => {
      if (rg === null) {
        const index = group.relativeGroup.indexOf(rg);
        group.relativeGroup.splice(index, 1);
      }
    });
    this.adminService.addRelative(group).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.successInfo = true;
          this.errorInfo = false;
          this.errorName = false;
        } else {
          this.errorMsg = 'ERROR_ADDING_RELATIVE_GROUPS';
          this.successInfo = false;
          this.errorInfo = true;
        }
      },
      () => {
        this.errorMsg = 'ERROR_ADDING_RELATIVE_GROUPS';
        this.successInfo = false;
        this.errorInfo = true;
      }
    );
  }

  isGroupNameValid(name: string) {
    if (name.startsWith(' ') || name.endsWith(' ')) {
      return false;
    }
    const spaces = name.search(/ {2,}/g);
    if (spaces > 0) {
      return false;
    }
    return !(name == null || name.length < 5 || isUndefined(name));
  }

  editAllDivisions(flexibleWorkSchedules) {
    this.isLoading = true;
    this.editPrefix();
    this.errorMsg = '';
    this.successInfo = false;
    this.errorInfo = false;
    this.errorName = false;
    const group = {
      name: this.titleValue,
      id: this.group.id,
      workScheduleId: this.selectedScheduleId,
      workScheduleId2: this.selectedScheduleId2 ? this.selectedScheduleId2 : null,
      workScheduleId3: this.selectedScheduleId3 ? this.selectedScheduleId3 : null,
      workScheduleCheckvox: this.workScheduleCheckvox,
      workSchedule2Checkvox: this.workSchedule2Checkvox,
      workSchedule3Checkvox: this.workSchedule3Checkvox,
      flexibleWorkSchedules: flexibleWorkSchedules,
      groupType: this.selectedType,
      relativeGroup: [
        this.selectedSubdivisionId
      ]
    }
    if (this.titleValue === this.currentGroupName) {
      group.name = null;
    } else {
      this.currentGroupName = group.name;
    }
    if (this.selectedType === 'AFFILIATE') {
      group.relativeGroup = this.selectedSubdivisions;
    }
    this.adminService.updateGroup(group).subscribe(
      (response: any) => { 
        this.isLoading = false;
        this.messageDanger = '';
        this.messageSuccess = 'SCHEDULE_UPDATING';
        setTimeout(() => {
          this.messageSuccess = '';
        }, 3000);
      },
      (err) => {
        this.dropdowns = JSON.parse(JSON.stringify(this.originalDropdowns));
        const parsedData = this.parseString(err.error.message);
        this.updateDropdownsWithParsedData(this.dropdowns, parsedData);
        this.isLoading = false;
        this.messageSuccess = '';
        this.messageDanger = 'ERRORCONFLICT';
        setTimeout(() => {
          this.messageDanger = '';
        }, 5000);
      }
    );
  }

  updateDropdownsWithParsedData(dropdowns, parsedData) {
    parsedData.forEach(parsedItem => {
      dropdowns.forEach(dropdown => {
        if (dropdown.id === parsedItem.scheduleId) {
          parsedItem.selectedScheduleName = dropdown.selectedScheduleName; 
          dropdown.selectedScheduleName = parsedItem.teamName; 
        }
      });
    });
    this.constName = parsedData;
  }

  parseString(input: string) {
    const regex = /CreateUpdateDto\(teamName=([^,]+),\s*scheduleId=([a-z0-9]+)\)/gi;
    let matches;
    const parsedData = [];
  
    while ((matches = regex.exec(input)) !== null) {
      parsedData.push({
        teamName: matches[1],
        scheduleId: matches[2],
        selectedScheduleName: null 
      });
    }
  
    return parsedData;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/edit-group-details/edit-group-details.component.ts